import { Layers3 } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const StackIcon = createLucideIcon(Layers3);
